import downloadFile from '@/utils/downloadFile';

const usePdfActions = () => {
  const downloadPdf = (pdfBase64: string, pdfFilename: string) => {
    if (!pdfBase64) return;

    downloadFile(pdfBase64, pdfFilename, 'application/pdf');
  };

  const printPdf = (pdfBase64: string) => {
    const byteCharacters = atob(pdfBase64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const blobUrl = URL.createObjectURL(blob);

    const printWindow = window.open(blobUrl, '_blank');
    if (!printWindow) {
      console.error('Popup blocked');
      return;
    }

    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print();
    };
  };

  return {
    downloadPdf,
    printPdf,
  };
};

export default usePdfActions;
